/**
 * Información de contacto
 * Bloque visual con datos de contacto de la empresa
 */

import React from 'react';

/**
 * Componente de información de contacto
 * @returns {JSX.Element} Información de contacto
 */
const ContactInfo = () => {
  return (
    <div className="bg-intercasa-bone rounded-lg p-8 md:p-12">
      {/* Grid de dos columnas - elementos alineados por filas */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-x-12 md:gap-y-10">
        {/* Fila 1: Dirección y Email */}
        {/* Dirección */}
        <div className="flex items-start">
          <div className="flex-shrink-0 w-12 h-12 bg-intercasa-red rounded-lg flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div>
            <h3 className="font-baskerville text-lg font-bold text-intercasa-dark mb-2">
              Dirección
            </h3>
            <p className="text-intercasa-gray leading-relaxed">
              Carretera General del Sur, km 42<br />
              35107 Juan Grande<br />
              San Bartolomé de Tirajana<br />
              Gran Canaria, Islas Canarias<br />
              España
            </p>
          </div>
        </div>

        {/* Email */}
        <div className="flex items-start">
          <div className="flex-shrink-0 w-12 h-12 bg-intercasa-red rounded-lg flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h3 className="font-baskerville text-lg font-bold text-intercasa-dark mb-2">
              Correo electrónico
            </h3>
            <p className="text-intercasa-gray">
              <a 
                href="mailto:info@intercasacanarias.es" 
                className="hover:text-intercasa-red transition-colors duration-300"
              >
                info@intercasacanarias.es
              </a>
            </p>
          </div>
        </div>

        {/* Fila 2: Teléfono y Horario */}
        {/* Teléfono */}
        <div className="flex items-start">
          <div className="flex-shrink-0 w-12 h-12 bg-intercasa-red rounded-lg flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </div>
          <div>
            <h3 className="font-baskerville text-lg font-bold text-intercasa-dark mb-2">
              Teléfono
            </h3>
            <p className="text-intercasa-gray">
              <a 
                href="tel:+34928732001" 
                className="hover:text-intercasa-red transition-colors duration-300"
              >
                +34 928 732 001
              </a>
            </p>
          </div>
        </div>

        {/* Horario */}
        <div className="flex items-start">
          <div className="flex-shrink-0 w-12 h-12 bg-intercasa-red rounded-lg flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="font-baskerville text-lg font-bold text-intercasa-dark mb-2">
              Horario de atención
            </h3>
            <p className="text-intercasa-gray">
              Lunes a viernes<br />
              de 8:00 a 15:00
            </p>
          </div>
        </div>
      </div>

      {/* Nota adicional - Ocupa todo el ancho */}
      <div className="border-t border-gray-200 pt-6 mt-8">
        <p className="text-sm text-intercasa-gray leading-relaxed">
          <strong className="text-intercasa-dark">Nota:</strong> Nuestro equipo estará encantado de atenderte durante nuestro horario comercial. 
          Si nos escribes fuera de estas horas, te responderemos lo antes posible el siguiente día laborable.
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;